if (!customElements.get("footer-section")) {
  customElements.define(
    "footer-section",
    class FooterSection extends HTMLElement {
      constructor() {
        super();
      }
      toggleMenu(event) {
        const button = event.currentTarget;
        const container = button.parentElement;
        const content = container?.querySelector("[data-footer-menu-link-content]");
        const icon = button.querySelector("svg");
        if (content) {
          content.classList.toggle("opacity-0");
          content.classList.toggle("h-0");
          content.classList.toggle("overflow-hidden");
          if (content.classList.contains("h-0")) {
            content.setAttribute("inert", "");
          } else {
            content.removeAttribute("inert");
          }
        }
        if (icon) {
          icon.classList.toggle("rotate-90");
          icon.classList.toggle("-rotate-90");
        }
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isExpanded));
      }
      setupToggleButtons() {
        const toggleButtons = this.querySelectorAll("[data-footer-menu-link-toggle]");
        toggleButtons.forEach((button) => {
          button.addEventListener("click", this.toggleMenu.bind(this));
        });
      }
      applyInitialInert() {
        const isMobile = typeof window !== "undefined" && window.innerWidth < 1024;
        const contents = this.querySelectorAll("[data-footer-menu-link-content]");
        if (isMobile) {
          contents.forEach((content) => {
            if (content.classList.contains("h-0")) {
              content.setAttribute("inert", "");
            }
          });
        }
        if (typeof window !== "undefined") {
          const mq = window.matchMedia("(min-width: 1024px)");
          const onBreakpoint = (e) => {
            if (e.matches) {
              contents.forEach((c) => c.removeAttribute("inert"));
            } else {
              contents.forEach((c) => {
                if (c.classList.contains("h-0")) c.setAttribute("inert", "");
              });
            }
          };
          mq.addEventListener("change", onBreakpoint);
        }
      }
      init() {
        this.setupToggleButtons();
        this.applyInitialInert();
      }
      // Lifecycle callback when the element is connected to the DOM
      connectedCallback() {
        this.init();
      }
    }
  );
}
